import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { SettingsService } from "../settings/settings.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private settings: SettingsService) {

    }

    intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const authReq = req.clone({
            headers: new HttpHeaders({
                'Authorization': this.settings.getUserSetting('token') ? this.settings.getUserSetting('token') : '',
            })
        });

        // console.log('Intercepted HTTP call', authReq);

        return next.handle(authReq);
    }
}


// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/core/guards/auth.interceptor.ts